import { dropTask } from 'ember-concurrency';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type Store from '@ember-data/store';
import Button from 'tio-reimagined/components/button';
import { PhFileArrowDown } from 'ember-phosphor-icons';

interface DownloadButtonSignature {
  Args: {
    filename: string;
    url?: string;
    needsUrl?: (passthru?: unknown) => Promise<string>;
    label?: string;
  };
  Element: HTMLElement;
}

export default class DownloadButton extends Component<DownloadButtonSignature> {
  @service declare store: Store;

  get filename() {
    return this.args.filename || 'tuition';
  }

  download = dropTask(async () => {
    let url = this.args.url;
    const { filename } = this;

    if (!url && this.args.needsUrl) {
      url = await this.args.needsUrl();
      if (!url) {
        return;
      }
    } else if (!url) {
      return;
    }

    const adapter = this.store.adapterFor('application');
    const headers = adapter.headers;

    const response = await fetch(url, { headers });

    if (response.ok) {
      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = fileUrl;
      tempLink.setAttribute('download', filename);

      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    } else {
      console.error('Unable to download file due to an error.', response);
    }
  });

  <template>
    {{#if @label}}
      <Button
        @intent="primary"
        @appearance="outlined"
        @isRunning={{this.download.isRunning}}
        @label={{@label}}
        {{on "click" this.download.perform}}
        ...attributes
      />
    {{else}}
      <Button
        @intent="primary"
        @appearance="outlined"
        @isRunning={{this.download.isRunning}}
        {{on "click" this.download.perform}}
        ...attributes
      >
        <PhFileArrowDown @size="24" />
      </Button>
    {{/if}}
  </template>
}
